import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Text } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';
import ErrorImage from './images/Error.svg';

import styles from './styles';

const useStyles = createUseStyles(styles, 'ErrorView');

const ErrorView = memo(({ icon, ...props }) => {
    const classes = useStyles();
    const { t } = useWeb5Context();
    const title = props.title || t('error_an_error_occurred');
    const subtitle = props.subtitle || t('error_reload_table');
    const button = props.button;

    return (
        <div className={classes.viewContainer}>
            <div className={classes.emptyView}>
                <ErrorImage />
                <Text type="subtitle1" bold>
                    {title}
                </Text>
                <Text>{subtitle}</Text>
                {button && <div className={classes.emptyButton}>{button}</div>}
            </div>
        </div>
    );
});

ErrorView.propTypes = {
    icon: PropTypes.node,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    button: PropTypes.element,
};

export default ErrorView;
